import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import { formInputSx, themedFormInputSx } from "../common/formFieldStyles";
import { COLORS } from "../../styles/uiConstants";

const PAPER_SX = {
  borderRadius: 2,
  border: `1px solid ${COLORS.slate200}`,
  boxShadow: "0 8px 24px rgba(15,23,42,0.12)",
  mt: 0.5,
};

const LISTBOX_SX = {
  maxHeight: 360,
  py: 0.5,
  "& .MuiAutocomplete-option": {
    fontSize: "0.85rem",
    py: 0.875,
    px: 1.5,
    whiteSpace: "normal",
  },
  "& .MuiAutocomplete-option[aria-selected='true']": {
    bgcolor: COLORS.slate100,
  },
};

/**
 * Tüm menülerde kullanılacak standart arama dropdown (Autocomplete).
 * FormSelect ile aynı görünümde.
 *
 * Opt-in: `variant` ("outlined" varsayılan | "standard" — drawer'larda),
 * `palette` (klinik rengiyle odak), `textFieldProps` (iç input'a ek prop'lar,
 * ör. helperText, required, InputLabelProps). `renderInput` verilirse o kullanılır.
 */
export default function FormAutocomplete({
  label,
  options = [],
  value,
  onChange,
  getOptionLabel,
  isOptionEqualToValue,
  sx = {},
  disabled = false,
  placeholder,
  size = "small",
  ListboxProps,
  componentsProps,
  variant,
  palette,
  textFieldProps,
  ...rest
}) {
  const inputSx = { ...(palette ? themedFormInputSx(palette) : formInputSx), ...sx };

  return (
    <Autocomplete
      options={options}
      value={value ?? null}
      onChange={onChange}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue || ((a, b) => a?._id === b?._id)}
      disabled={disabled}
      size={size}
      sx={{ minWidth: 0, ...sx }}
      ListboxProps={{
        ...ListboxProps,
        sx: { ...LISTBOX_SX, ...(ListboxProps?.sx || {}) },
      }}
      componentsProps={{
        ...componentsProps,
        paper: {
          ...componentsProps?.paper,
          sx: { ...PAPER_SX, ...(componentsProps?.paper?.sx || {}) },
        },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          variant={variant}
          {...textFieldProps}
          sx={{ ...inputSx, ...(textFieldProps?.sx || {}) }}
        />
      )}
      {...rest}
    />
  );
}
